import { useEffect, useRef } from "react";
import { isTemporaryPackChatError } from "@/payroll/pack-chat/thread-error-copy";
import { currentPayrollResult } from "@/payroll/teams/query-result";

export const useCurrentPackChatResult = <
  T extends Parameters<typeof currentPayrollResult>[0] & {
    error: unknown;
    dataUpdatedAt: number;
  },
>(
  query: T,
  scope: string,
): Omit<T, "data" | "isLoading"> & {
  data: T["data"] | undefined;
  isLoading: boolean;
} => {
  const baseline = useRef({ scope, dataUpdatedAt: query.dataUpdatedAt });
  if (baseline.current.scope !== scope) {
    baseline.current = { scope, dataUpdatedAt: query.dataUpdatedAt };
  }
  useEffect(() => {
    if (query.isError && !isTemporaryPackChatError(query.error)) {
      baseline.current.dataUpdatedAt = query.dataUpdatedAt;
    }
  }, [query.isError, query.error, query.dataUpdatedAt]);
  const current = currentPayrollResult(query);
  return {
    ...current,
    data:
      query.dataUpdatedAt > baseline.current.dataUpdatedAt &&
      isTemporaryPackChatError(query.error)
        ? query.data
        : current.data,
  };
};
